import React, { FC, useEffect } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { purgeSessionKey, purgeUser } from "../../utils/SsoSession";
import Loader from "react-loaders";
import { RiLogoutBoxLine } from "react-icons/ri";
import ClientStore from "../Admin/ClientManagement/store";
import { MessageResultState } from "../../types/general-types";

const LogoutPage: FC = observer(() => {
  const { t } = useTranslation();
  useEffect(() => {
    setTimeout(() => {
      purgeSessionKey();
      purgeUser();
      const queryParams = new URLSearchParams(window.location.search);
      const clientId = queryParams.get("clientId");
      if (clientId) {
        new ClientStore().getById(clientId).then((res) => {
          if (res.state === MessageResultState.SUCCESS) {
            if (res.result.logoutUri && res.result.logoutUri !== "") {
              window.location.href = res.result.logoutUri;
            } else {
              window.location.href = "login";
            }
          }
        });
      } else {
        window.location.href = "login";
      }
    }, 3000);
  }, []);

  return (
    <div className="container h-100 ">
      <div className="row h-100 justify-content-center align-items-center content">
        <div style={{ width: "100%" }}>
          <h1 className="row h-100 justify-content-center align-items-center display-1">
            <RiLogoutBoxLine />
          </h1>
          <div className="d-flex flex-column justify-content-center align-items-center">
            <span className="display-5">{t("Checking out..")}</span>
            <span className="display-5">
              {t("You will be redirected to the login page in three seconds..")}
            </span>
            <div className="d-flex justify-content-center align-items-center mb-5">
              <Loader type="ball-triangle-path" active />
            </div>
            <div className=" mt-5" style={{ textAlign: "center" }}>
              <img
                src="https://www.securitas.com.tr/build/images/brand/securitas_ab_logo_alt.svg"
                width="100px"
                alt=""
              />
              <div className="mb-2" style={{ textAlign: "center" }}>
                <strong>
                  <p>Securitas Güvenlik Hizmetleri A.Ş.</p>
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default LogoutPage;
